<template>
    <section class="QuizPersonality ContentSection">

        <!-- quiz -->
        <div class="QuizPersonality__quiz" v-if="!quizComplete">

            <div class="QuizPersonality__quiz__question">
                <h5 v-html="currentQuestion.question"></h5>
            </div>

            <div class="QuizPersonality__quiz__answers">
                <transition-group @enter="onQuestionEnter" @before-enter="onBeforeQuestionEnter" @leave="onQuestionLeave"
                    name="list" appear>
                    <button v-for="answer, i in currentQuestion.answerOptions" :key="answer.text" :data-index="i"
                        @click="answerQuestion(answer)">{{ answer.text }}</button>
                </transition-group>
            </div>

            <div class="QuizPersonality__quiz__bottomnav">
                <span class="progress" v-html="quizProgress"></span>
                <button @click="answerQuestion()">Skip<img src="@/assets/img/ui/skip.svg" /></button>
            </div>

        </div>





        <!-- results -->
        <div class="QuizPersonality__results" v-else>


            <div v-if="answeredQuestionsCount > 0">
                <h5 v-html="properties.resultTitle"></h5>

                <!-- accordion -->
                <div class="QuizMultiplePath__results_accordion">

                    <article v-for="accordion in sortedResponses" :key="accordion.title">
                        <button @click="openAccordionClick(accordion)">
                            <span v-html="accordion.score"></span>
                            {{ accordion.title }}
                            <img src="@/assets/img/ui/accordion-plus.svg" v-if="!accordion.open" />
                            <img src="@/assets/img/ui/accordion-close.svg" v-else />
                        </button>

                        <div v-if="accordion.open">
                            <div v-html="accordion.text" class="AccordionInfo__text"></div>
                        </div>
                    </article>

                </div>


                <!-- <p class="QuizPersonality__results_smallheader" v-html="resultWithHighestScore.shortText"></p>
                <p v-html="resultWithHighestScore.text"></p> -->



                <p class="QuizPersonality__results_smallheader double-space">Hent som pdf</p>

                <PDFGenerator :headerTitle="'Find dine superkræfter'" :color="pageData.color" :buttonText="'DOWNLOAD'"
                    :PDFName="properties.resultTitle">

                    <h3 class="pdf__element pdf__subtitle">{{ properties.resultTitle }}</h3>

                    <template v-for="(accordion, i) in sortedResponses" :key="accordion.title">

                        <article class="pdf__element pdf__listitem">

                            <div class="pdf__listitem__title">
                                <span>{{ accordion.score }} points</span>
                                {{ accordion.title }}
                            </div>

                            <div class="pdf__listitem__text" v-html="accordion.text"></div>

                        </article>

                        <!-- page break hver 3 svar, men kun 2 på første side -->
                        <div class="html2pdf__page-break"></div>

                    </template>

                </PDFGenerator>

            </div>


            <div v-else>
                <h5 v-html="properties.resultsNotFoundTitle"></h5>
                <p v-html="properties.resultsNotFoundText"></p>
                <p><a class="Button" @click="initQuiz()">

                        Prøv igen...
                    </a>
                </p>
            </div>

        </div>

    </section>
</template>
<script>
import gsap from 'gsap';
import PDFGenerator from '../util/PDFGenerator.vue';

export default {
    props: ["properties", "pageData"],
    components: {
        PDFGenerator
    },
    data() {
        return {
            activeQuestion: 0,
            questions: [],
            results: [],
            quizComplete: false,
            resultsHTML: null,
            answeredQuestionsCount: 0,
            resultWithHighestScore: {},
        };
    },
    created() {
        this.initQuiz();
    },
    methods: {

        initQuiz() {

            // this.properties.questions.splice(0, 15);

            this.questions = this.properties.questions.map((question, i) => {
                question.id = `q__${i}`;
                return question;
            });


            this.results = this.properties.results.map((result, i) => {
                result.score = 0;
                return result;
            });

            this.quizComplete = false;
            this.activeQuestion = 0;

        },

        answerQuestion(answer) {

            // no answer = skip!
            if (answer) {
                // count score on given result pool
                var resultToAddOnePoint = this.results.find(x => x.resultId === answer.resultPool);
                if (resultToAddOnePoint)
                    resultToAddOnePoint.score++;
                this.answeredQuestionsCount++;
            }

            // are we there yet?
            if (this.activeQuestion == this.questions.length - 1) {
                this.endQuiz();
                return;
            }

            if(this.answeredQuestionsCount === 1)
                _paq.push(["trackEvent", "quiz", "quiz-started", window.app.vm.$route.path]);

            this.activeQuestion++;
        },

        endQuiz() {

            // find result
            if (this.answeredQuestionsCount > 0) {
                this.resultWithHighestScore = this.results.reduce((max, result) => max.score > result.score ? max : result);
            }

            this.quizComplete = true;
            _paq.push(["trackEvent", "quiz", "quiz-ended", window.app.vm.$route.path]);
            this.getHTML();
        },
        getHTML() {
            this.resultsHTML = document.getElementById('app');
        },


        openAccordionClick(accordion) {
            let i = 0;
            while (i < this.results.length) {
                if (accordion.title !== this.results[i].title) {
                    this.results[i].open = false;
                } else {
                    accordion.open = !accordion.open
                }

                i++;
            }
        },


        generateReport() {
            this.$refs.html2Pdf.generatePdf()
        },

        onProgress() {
            console.log("pdf creating..")
        },




        // animations
        onBeforeQuestionEnter(el) {
            gsap.set(el, {
                opacity: 0,
                x: -20
            })
        },
        onQuestionEnter(el, done) {
            gsap.to(el, {
                duration: 0.5,
                opacity: 1,
                x: 0,
                delay: el.dataset.index * 0.2,
                onComplete: done
            })
        },
        onQuestionLeave(el, done) {
            gsap.set(el, {
                opacity: 0,
                onComplete: done
            })
        }
    },
    computed: {
        currentQuestion() {
            return this.questions[this.activeQuestion];
        },

        quizProgress() {
            let currentSlide = (this.activeQuestion + 1).toString();
            let addPadding = currentSlide.length < 2 && this.questions.length >= 10;

            return `${addPadding ? "0" + currentSlide : currentSlide} | ${this.questions.length}`;
        },
        sortedResponses() {
            let results = this.results;

            results.sort(function (a, b) {
                return b.score - a.score;
            });

            // åbn første (flest points)
            results.forEach(result => {
                result.open = false;
            });
            results[0].open = true;

            return results;
        },
    },
};
</script>


<style lang="scss">
@import '@/assets/sass/_responsiveness.scss';

.QuizPersonality {
    display: flex;
    align-items: center;
    flex-direction: column;
    flex-grow: 1;
    padding-top: 120px;
    padding-bottom: 120px;
    background: var(--light-grey);

    &>div {
        position: relative;
        display: block;

        width: 100%;
        max-width: var(--content-max-width);
        text-align: left;

        &.QuizPersonality__quiz {
            min-height: 280px;
            padding: var(--content-padding);

            .QuizPersonality__quiz__question {
                h5 {
                    padding: 0;
                }

                margin-bottom:50px;
            }

            .QuizPersonality__quiz__answers {
                button {

                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    min-height: 60px;
                    background-color: #fff;
                    margin-bottom: 20px;
                    width: 100%;
                    padding: 25px 50px 25px 30px;
                    border-radius: 30px;
                    background-image: url(@/assets/img/ui/btn-arrow.svg);
                    background-position: right 20px bottom 50%;
                    background-repeat: no-repeat;
                    transition: transform 0.1s ease;

                    &:hover {
                        transform: scale(1.03) !important;
                    }
                }
            }

            .QuizPersonality__quiz__bottomnav {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;

                button {
                    display: flex;
                    align-items: center;
                    cursor: pointer;

                    &>img {
                        margin-left: 14px;
                    }
                }

                .progress {
                    margin-left: 10px;
                    font-weight: bold;
                }
            }
        }

        &.QuizPersonality__results {
            flex-direction: column;
            text-align: left;

            p {
                margin: 1em 0;

                &.double-space {
                    margin: 2em 0 1em;
                    ;
                }
            }


            h5 {
                margin-bottom: 20px;
            }


            .QuizMultiplePath__results_accordion {
                width: 100%;
                max-width: var(--content-max-width);
                padding: var(--content-padding);


                &>article {
                    width: 100%;

                    border-bottom: solid 1px #000;

                    &:first-of-type {
                        border-top: solid 1px #000;
                    }

                    &>div {
                        padding: 0px 0 40px 0;
                    }

                    .AccordionInfo__text>p {
                        padding: 0;
                    }

                    &>button {
                        position: relative;
                        display: flex;
                        align-items: center;
                        font-size: 16px;
                        font-weight: bold;
                        min-height: 60px;
                        padding: 25px 40px 25px 0;

                        &>span {
                            flex: none;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            width: 24px;
                            height: 24px;
                            border-radius: 100%;
                            border: solid 2px #000;
                            background: #fff;
                            margin-right: 12px;
                            padding-bottom: 4px;
                        }

                        &>img {
                            position: absolute;
                            right: 0;
                            top: 50%;
                            transform: translateY(-50%);
                        }
                    }
                }

                button {
                    cursor: pointer;
                    width: 100%;
                }
            }


            .QuizPersonality__results_smallheader {
                font-weight: bold;

            }

            .QuizPersonality__results_pdf {
                font-weight: bold;
                margin-top: 2em;
            }

            a.arrow-link {
                padding-left: 20px;
                background-image: url(@/assets/img/ui/btn-arrow.svg);
                background-position: left 0px bottom 50%;
                background-repeat: no-repeat;
                margin: 20px 0;
                display: block;
            }

            .Button {
                display: flex;
                line-height: 2em;
                background-color: #000;
                color: #fff;
                margin-top: 30px;
            }

        }
    }

    // exp
    .list-leave-active {
        position: absolute;
    }


    @include mobile-only {

        padding-top: 80px
    }

}
</style>